




























import { Event, PhysicalAddress } from '@ssp/inscreva-sse-models';
import { Component, Prop, Vue } from 'vue-property-decorator';

import { EventUI } from '../models/event-ui';
import LocationMap from './LocationMap.vue';

@Component({
  components: {
    LocationMap,
  },
})
export default class EventDetailsComponent extends Vue {
  @Prop({ required: true })
  eventUI: EventUI;

  showMap = false;

  get event() {
    return this.eventUI.event as Event;
  }

  get eventLink() {
    return this.eventUI.is_online ? `${window.location.origin}/${this.eventUI.alias}` : false;
  }

  get eventPlace() {
    return this.eventUI.is_online ? false : (this.event.info.place as PhysicalAddress);
  }
}
